import React from 'react';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors } from 'polygon-ordering';
import Warning from './Warning';
import getInvalidStagedPurchasePresent from '../selectors/getInvalidStagedPurchasePresent';
import getShowMinExcludesSurchargeMessage from '../selectors/getShowMinExcludesSurchargeMessage';
import getInvalidOfferPresent from '../selectors/getInvalidOfferPresent';
import { DELIVERY_SALE_TYPES } from '../libs/polygon-ordering/src/constants';
import { Message } from './OrderMessages';
import { useTranslation } from 'react-i18next';
import { stagedPurchaseContainsAlcoholicItems } from '../libs/polygon-ordering/src/utils/ordering/filterAlcoholic';

const {
  getSaleType,
  getStagedPurchases,
  getSelectedOfferMiniSpendingDiffTotalPrice,
  getSelectedOffer,
  getCurrencySymbol,
  getStagedPurchaseCount,
} = OrderingSelectors;

const Warnings: React.FC = () => {
  const { t } = useTranslation();
  const saleType = useAppSelector(getSaleType);
  const enableFraudPreventionMessage = useAppSelector(
    state => state.config.enableFraudPreventionMessage,
  );
  const isDelivery = DELIVERY_SALE_TYPES.includes(saleType);
  const invalidStagedPurchasePresent = useAppSelector(getInvalidStagedPurchasePresent);
  const showMinExcludesSurchargeMessage = useAppSelector(getShowMinExcludesSurchargeMessage);
  const invalidOfferPresent = useAppSelector(getInvalidOfferPresent);
  const stagedPurchases = useAppSelector(getStagedPurchases);
  const cartIncludesAlcohol = stagedPurchases.some(purchase =>
    stagedPurchaseContainsAlcoholicItems(purchase),
  );
  const selectedOffer = useAppSelector(getSelectedOffer);
  const currency = useAppSelector(getCurrencySymbol);
  const minimumCouponAmountNotMet = useAppSelector(getSelectedOfferMiniSpendingDiffTotalPrice);
  const stagedPurchaseCount = useAppSelector(getStagedPurchaseCount);

  const getFraudPreventionMessage = () => {
    if (!enableFraudPreventionMessage) {
      return '';
    }

    if (isDelivery) {
      return 'fraudPreventionMessage.delivery';
    }

    return 'fraudPreventionMessage.collection';
  };

  return (
    <div>
      <Warning
        message={getFraudPreventionMessage()}
        visible={Boolean(enableFraudPreventionMessage)}
      />
      <Warning
        message="invalidStagedPurchasePresentMessage"
        visible={invalidStagedPurchasePresent}
        showAlertIcon
      />
      <Warning
        message="minimumExcludesSurchargeMessage"
        visible={showMinExcludesSurchargeMessage}
      />
      <Warning message="incompatibleOfferMessage" visible={invalidOfferPresent} showAlertIcon />
      <Warning message="checkoutItemHasAlcohol" visible={cartIncludesAlcohol} showAlertIcon />
      {!invalidOfferPresent && minimumCouponAmountNotMet > 0 && Boolean(stagedPurchaseCount) && (
        <div style={styles.couponContainer}>
          <Message
            message={t('minimumOrderWithCouponMessage', {
              amount: minimumCouponAmountNotMet / 100.0,
              minimum: selectedOffer?.MinOrderValue,
              currency,
            })}
            showAlertIcon
          />
        </div>
      )}
    </div>
  );
};

const styles: Styles = {
  couponContainer: {
    textAlign: 'center',
  },
};

export default Warnings;
